module.exports = __webpack_public_path__ + "assets/img/high.4f6d311c.svg";